{
  "projectAttributes": {
    "title": "Attribute Settings",
    "subtitle": "Here you can add and delete predefined attributes that your project users can view and use.",
    "predefined_title": "Predefined attributes",
    "predefined_text": "Customise your project's predefined attributes which can be added to plan layers.",
    "no_attributes": "There are no project attributes, create one using the add attribute button above",
    "active_tab": "Active",
    "deprecated_tab": "Inactive",
    "no_deprecated_attributes": "There are no inactive project attributes",
    "deprecate_confirmation_title": "Deactivate attribute?",
    "deprecate_confirmation_message": "This attribute is in use and cannot be deleted. It will be deactivated instead. Inactive attributes are hidden when adding attributes to layers, but will remain on layers where they have already been added.",
    "delete_confirmation_title": "Delete attribute?",
    "delete_confirmation_message": "Are you sure you want to delete this attribute? This action cannot be undone.",
    "restore_button": "Restore"
  }
}